import MainLayout from "../../components/layout/mainlayout/MainLayout";

import HomeHero from "../../components/home/HomeHero";
import StatsBar from "../../components/home/StatsBar";
import ServicesPreview from "../../components/home/ServicesPreview";
import FeaturedProjects from "../../components/home/FeaturedProjects";
import AwardsSection from "../../components/home/AwardsSection";
import ClientLogos from "../../components/home/ClientLogos";
import HomePartnerInquiry from "../../components/home/HomePartnerInquiry";
import HomeCTA from "../../components/home/HomeCTA";
import WhyChooseSAC from "../../components/home/WhyChooseSAC";
import HomeSACDifference from "../../components/home/HomeSACDifference";
import HomeGlobalPresence from "../../components/home/HomeGlobalPresence";

export default function Home() {
  return (
    <MainLayout noTopPadding>
      <HomeHero />

      <div className="bg-gradient-to-b from-transparent to-white">
        <StatsBar />
      </div>

      <WhyChooseSAC />
      <ServicesPreview />
      <HomeSACDifference />
      <FeaturedProjects />
      <HomeGlobalPresence />
      <AwardsSection />
    
      <ClientLogos />
      <HomeCTA />
      <HomePartnerInquiry />
    </MainLayout>
  );
}
